var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"justify-center px-0 pb-15 pt-0",staticStyle:{"background-color":"white","height":"100%"},attrs:{"fluid":"","align":"left"}},[_c('div',{staticClass:"pb-15 mb-5",style:({
      backgroundImage: 'url(' + require('@/assets/fdi_red_curve.png') + ')',
      backgroundSize: '100% 100%',
      paddingTop: '168px',
    })},[_c('h1',{staticClass:"text-center text-sm-h3 text-h4 white--text mb-4"},[_vm._v("Privacy Policy")])]),(_vm.policyDocument)?_c('div',{staticClass:"ma-7",domProps:{"innerHTML":_vm._s(_vm.policyDocument.body)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }